export interface BffHealthzResponse {
    status?: string;
    ok?: boolean;
    [key: string]: unknown;
}

export interface BffLoginRequest {
    email: string;
    password: string;
}

export interface BffLoginOptionsRequest {
    email: string;
}

export interface BffLoginOptionsResponse {
    expiresIn: number;
    passwordAllowed: boolean;
    passwordlessAllowed: boolean;
}

export interface BffLoginPasswordRequest {
    password: string;
}

export interface BffLoginPasswordResponse {
    authenticated: boolean;
    spaceId?: string;
    userId?: string;
    expiresAt?: number;
    expiresIn?: number;
    methods?: string[];
    mfaRequired?: boolean;
}

export interface BffPasswordlessStartResponse {
    expiresIn: number;
}

export interface BffPasswordlessVerifyRequest {
    otp: string;
}

export interface BffPasswordlessSelectableSpace {
    spaceId: string;
    slug: string;
    name: string;
}

export interface BffPasswordlessVerifyResponse {
    authenticated: boolean;
    spaceId?: string;
    userId?: string;
    expiresAt?: number;
    status?: string;
    expiresIn?: number;
    selectionCode?: string;
    spaces?: BffPasswordlessSelectableSpace[];
}

// Public signup metadata is rendered only after the BFF confirms the email code.
export interface SignUpField {
    ID?: string;
    Key?: string;
    Title?: string;
    Description?: string;
    Placeholder?: string;
    Type?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    DefaultValue?: string;
    DefaultValues?: string[];
    Options?: string[];
    Required?: boolean;
    Order?: number;
}

export interface SignUpStage {
    ID?: string;
    Title?: string;
    Description?: string;
    Fields?: SignUpField[];
    Order?: number;
}

export interface PublicSignUpConfig {
    signUpStrategy: 'open' | 'invite-only' | 'approval';
    signUpStages: SignUpStage[] | null;
}

export interface BffSessionResponse {
    authenticated: boolean;
    spaceId?: string;
    userId?: string;
    expiresAt?: number;
}

export type AuthFlowStep = 'email' | 'password' | 'passwordless';

export interface AuthFlowState {
    email: string;
    step: AuthFlowStep;
    availableMethods: string[];
    expiresIn: number;
    passwordlessStarted: boolean;
    passwordlessExpiresIn: number;
}

export type AuthStatus = 'idle' | 'loading' | 'unauthenticated' | 'authenticated';

export interface AuthState {
    csrfToken: string | null;
    errorCode: string | null;
    errorMessageKey: string | null;
    flow: AuthFlowState;
    session: BffSessionResponse | null;
    sessionLoading: boolean;
    sessionResolved: boolean;
    status: AuthStatus;
}

export const BFF_AUTH_ERROR_CODES = {
    expiredSession: 'expired-session',
    invalidCredentials: 'invalid-credentials',
    invalidOtp: 'invalid-otp',
    otpRequired: 'otp-required',
    unauthenticated: 'unauthenticated',
    unavailable: 'unavailable',
    validation: 'validation',
} as const;
